export class FormInfo {
    id: number;
    code: string;
    name: string;
    stepWeb: number;
    stepMobile: number;
    isActive: boolean;
    versionActive: number;
    isApproved: boolean;
}

export class FieldOption {
    id: number;
    fieldCode: string;
    optionValue: string;
    optionCode: string;
    order: number;
    allowInput: boolean;
    fieldOptionConfig: string;
    selectedInput:string;
    checked:boolean;
    hasSubSession:boolean;
}

export class FormFieldInfo {
    name: string;
    fieldTypeCode: string;
    defaultValue: string;
    formCode: string;
    environment: number;
    step: number;
    stepName: string;
    fieldCode: string;
    fieldConfig: string;
    formFieldConfig: string;
    order: number;
    width: number;
    isHidden: boolean;
    isRequired: boolean;
    isReadonly: boolean;
    formVersion: number;
    customfieldOptionList: FieldOption[]
}

export class ApiResponse<T> {
    result: ResponseResult<T>;
}

export class ResponseResult<T> {
    isSuccess: boolean;
    value: ResponseResultValue<T>;
    response: string;
    error: any;
    request: any;
    messageError: string;
}

export class ResponseResultValue<T> {
    result: T;
    targetUrl: any;
    success: boolean;
    error: any;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}